 
	jQuery(document).ready(function() {
	console.log("test header");
		jQuery('.featured-navigation__link-image').attr("alt","");
		jQuery('.jdgm-videos-wrapper img').attr("alt","");
        jQuery('.jdgm-arrow').attr("aria-label","Next Review");
        jQuery('.cart-order-notes__textarea').attr("aria-label","Leave a note for seller");
        jQuery('.jdgm-rev__pic-link').attr("aria-label","Review");

        
	jQuery('quantity-btn[name="minus"] button').attr('aria-label', 'Minus quantity');
	jQuery('quantity-btn[name="plus"] button').attr('aria-label', 'Plus quantity');
	jQuery('input[name="Color-2"]').attr('aria-label', 'color option');
	jQuery('textarea[name="contact[Comment]"]').attr('aria-label', 'Message');
	jQuery('textarea[name="comment[body]"]').attr('aria-label', 'Message');

    
	jQuery('.quick-view__close-button').attr('aria-label', 'close');

    
	jQuery('a:contains("Ask a question!")').attr('aria-label', 'Ask a question!');



    setTimeout(function(){ 
    jQuery('.jdgm-arrow').attr("aria-label","Next Review");
    jQuery('.jdgm-card.jdgm-media-card img').attr("alt","");
	jQuery('div[data-essential-upsell-element="discounted-price"] span').css('color', '#2C7CAA');

 

      },
  4000);


   });


   function updateJdgmImgAlt() {
  $('.jdgm-videos-wrapper img').attr('alt', '');
}

// initial run
updateJdgmImgAlt();

// watch for updates (slider replacement, lazy-load, etc.)
const observer = new MutationObserver(updateJdgmImgAlt);

observer.observe(document.querySelector('.jdgm-videos-wrapper'), {
  childList: true,
  subtree: true
});

 